// eslint-disable-next-line no-restricted-imports
import { Link as BaseLink } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';
import { twJoin } from 'tailwind-merge';

type Props = LinkProps;

export const Link = ({ className, children, ...rest }: Props) => {
  return (
    <BaseLink {...rest} className={twJoin('font-medium text-blue-600 dark:text-blue-500 hover:underline', className)}>
      {children}
    </BaseLink>
  );
};
